import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '@app/components/ui/Dialog/Dialog'
import { Button } from '@/components/ui/button'
import { RiskWorkspace } from '@app/types'

type WorkspaceDeleteDialogProps = {
  workspace: RiskWorkspace | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export const WorkspaceDeleteDialog = ({
  workspace,
  open,
  onOpenChange,
  onConfirm,
}: WorkspaceDeleteDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>Delete "{workspace?.name}"?</DialogTitle>
          <DialogDescription>This can't be undone.</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)} variant="outline">
            Cancel
          </Button>
          <Button onClick={onConfirm} variant="destructive">
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
